<template>
  <div>
    <h1>Playlist</h1>
    <div class="row">
      <div class="col-9">
        <VideoIFrame />
      </div>
      <div class="col right">
        <VideoPlayList />
      </div>
    </div>
  </div>
</template>

<script>
import VideoIFrame from "@/components/VideoIFrame.vue";
import VideoPlayList from "@/components/VideoPlayList.vue";

export default {
  components: {
    VideoIFrame,
    VideoPlayList
  }
};
</script>

<style scoped>
.row {
  margin: 0px;
}
</style>
